/* icon-new.tsx generated by @compiled/babel-plugin v2.0.0 */
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3iDTPbvbI6%7Bdisplay%3Ainline-block%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._24h04i2Njc%7Bbox-sizing%3Aborder-box%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3YEZNOdnbC%7Bflex-shrink%3A0%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._26BoRw7dHp%7Bline-height%3A1%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._03SyCPU7Rg%7Bpadding-inline-end%3Avar(--ds--button--new-icon-padding-end%2C0)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0LQT5ECyim%7Bpadding-inline-start%3Avar(--ds--button--new-icon-padding-start%2C0)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=%40media%20screen%20and%20(forced-colors%3Aactive)%7B._2z3AMPTxK4%7Bcolor%3ACanvasText%7D._1hdADdMFyn%7Bfilter%3Agrayscale(1)%7D%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._39xV02OLYo%7Bwidth%3Ainherit%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0jFU0VOLYo%7Bheight%3Ainherit%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._26BoRw8HPE%7Bline-height%3Avar(--ds-space-150%2C9pt)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4bt5LAnQyn%7Boverflow-x%3Ahidden%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2WAcuGnQyn%7Boverflow-y%3Ahidden%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1UtDYz98eZ%7Bcolor%3AcurrentColor%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1pp6NdYbGa%7Bpointer-events%3Anone%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1RrJLiUWqv%7Bvertical-align%3Abottom%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._24fbFs98eZ%20stop%7Bstop-color%3AcurrentColor%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._39xV028HPE%7Bwidth%3Avar(--ds-space-150%2C9pt)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0jFU0V8HPE%7Bheight%3Avar(--ds-space-150%2C9pt)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._39xV025zaO%7Bwidth%3Avar(--ds-space-200%2C1pc)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0jFU0V5zaO%7Bheight%3Avar(--ds-space-200%2C1pc)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._39xV02NHnM%7Bwidth%3Avar(--ds-space-300%2C24px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0jFU0VNHnM%7Bheight%3Avar(--ds-space-300%2C24px)%7D");
import { memo } from 'react';
import type { UNSAFE_NewGlyphProps } from '../types';

/**
 * We are hiding this props from consumers as it's reserved for use by Icon Tile.
 */
export type InternalIconPropsNew = UNSAFE_NewGlyphProps & {
  /**
   * @internal NOT FOR PUBLIC USE.
   * Sets whether the icon should inherit size from a parent. Used by Icon Tile.
   */
  shouldScale?: boolean;
};
const svgStyles = null;
const iconStyles = null;
const smallIconStyles = null;
const scaleStyles = null;

/**
 * For windows high contrast mode
 */
const baseHcmStyles = null;
const scaleSize = null;
const coreSizeMedium = {
  none: "_39xV025zaO _0jFU0V5zaO",
  compact: "_39xV02NHnM _0jFU0VNHnM",
  spacious: "_39xV02NHnM _0jFU0VNHnM"
};
const coreSizeSmall = {
  none: "_39xV028HPE _0jFU0V8HPE",
  compact: "_39xV025zaO _0jFU0V5zaO",
  spacious: "_39xV02NHnM _0jFU0VNHnM"
};
const paddingMap = ({
  medium: {
    none: 0,
    compact: 4,
    spacious: 4
  },
  small: {
    none: 0,
    compact: 2.66,
    spacious: 8
  }
} as const);

/**
 * __Icon__
 *
 * An icon is used as a visual representation of common actions and commands to provide context.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 */
export const Icon: import('react').NamedExoticComponent<import('../types').UNSAFE_NewCoreGlyphProps> = memo(function Icon(props: UNSAFE_NewGlyphProps) {
  const {
    color = 'currentColor',
    testId,
    label,
    // Used to set icon dimensions/behaviour in codegen
    // Used to set icon glyphs in codegen
    dangerouslySetGlyph,
    // Used with iconTile to scale icon up and down
    shouldScale,
    spacing = 'none',
    name
  } = (props as InternalIconPropsNew);
  const dangerouslySetInnerHTML = dangerouslySetGlyph ? {
    __html: dangerouslySetGlyph
  } : undefined;
  let size: 'medium' | 'small' = 'medium';
  if ('size' in props && props.size !== undefined) {
    if (typeof props.size === 'string') {
      size = props.size === 'small' || props.size === 'medium' ? props.size : size;
    } else if (name) {
      const newSize = props.size(name);
      size = newSize === 'small' || newSize === 'medium' ? newSize : size;
    }
  }
  const baseSize = 16;
  const viewBoxPadding = paddingMap[size][spacing];
  const viewBoxSize = baseSize + 2 * viewBoxPadding;
  return <span data-testid={testId} role={label ? 'img' : undefined} aria-label={label ? label : undefined} aria-hidden={label ? undefined : true} style={{
    color
  }} className={ax(["_3iDTPbvbI6 _24h04i2Njc _3YEZNOdnbC _26BoRw7dHp _03SyCPU7Rg _0LQT5ECyim", "_2z3AMPTxK4 _1hdADdMFyn", shouldScale && "_39xV02OLYo _0jFU0VOLYo", size === 'small' && "_26BoRw8HPE"])}>
			<svg fill="none"
    // Adjusting the viewBox allows the icon padding to scale with the contents of the SVG, which
    // we want for Icon Tile
    viewBox={`${0 - viewBoxPadding} ${0 - viewBoxPadding} ${viewBoxSize} ${viewBoxSize}`} role="presentation" dangerouslySetInnerHTML={dangerouslySetInnerHTML} className={ax(["_4bt5LAnQyn _2WAcuGnQyn _1UtDYz98eZ _1pp6NdYbGa _1RrJLiUWqv _24fbFs98eZ", shouldScale ? "_39xV02OLYo _0jFU0VOLYo" : size === 'small' ? coreSizeSmall[spacing] : coreSizeMedium[spacing]])} />
		</span>;
});

// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
export default Icon;